export enum LocalStorageKeys {
	auth = 'auth',
};
